export default __webpack_public_path__ + "public/images/apart/living-banner.png?9f9e3de6";